module.exports = __webpack_public_path__ + "static/img/scholarship.d8c8c5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scholarship.jpg
// module id = iA3O
// module chunks = 0